// Labels are i18n keys resolved via t() in useGskCopayConfiguration.
// Values are the canonical English contract strings persisted to the backend
// (matched against GSK_AP_INDICATIONS in GskCopayService) — do not translate them.
const GSK_INDICATION_OPTIONS = Object.freeze({
  NUCALA: [
    { label: "application_form_editor.gsk.copay.indication.severe_asthma", value: "Severe Asthma" },
    {
      label: "application_form_editor.gsk.copay.indication.chronic_rhinosinusitis_crswnp",
      value: "Chronic Rhinosinusitis with Nasal Polyps (CRSwNP)"
    },
    {
      label: "application_form_editor.gsk.copay.indication.egpa",
      value: "Eosinophilic Granulomatosis with Polyangitis (EGPA)"
    },
    { label: "application_form_editor.gsk.copay.indication.hes", value: "Hypereosinophilic Syndrome (HES)" },
    { label: "application_form_editor.gsk.copay.indication.i_dont_know", value: "I don't know" }
  ],
  EXDENSUR: [
    { label: "application_form_editor.gsk.copay.indication.severe_asthma", value: "Severe Asthma" },
    { label: "application_form_editor.gsk.copay.indication.moderate_asthma", value: "Moderate Asthma" },
    { label: "application_form_editor.gsk.copay.indication.nasal_polyps", value: "Nasal Polyps" },
    { label: "application_form_editor.gsk.copay.indication.i_dont_know", value: "I don't know" }
  ],
  BENLYSTA: [
    { label: "application_form_editor.gsk.copay.indication.lupus", value: "Lupus" },
    { label: "application_form_editor.gsk.copay.indication.lupus_nephritis", value: "Lupus nephritis" },
    { label: "application_form_editor.gsk.copay.indication.i_dont_know", value: "I don't know" }
  ]
});

export const getGskIndicationOptions = (drugDisplayName) =>
  GSK_INDICATION_OPTIONS[drugDisplayName?.toUpperCase()] || [];
